import { EVENT_CLICK_HIT } from '~~/constants/googleTagManager';

export const buildClickHitTags = ({
  userToken,
  index,
  objectIDs,
  searchTerm,
  positions,
}: {
  userToken?: string,
  index: string,
  objectIDs: string[],
  searchTerm: string,
  positions: number[]
}) => ({
  event: EVENT_CLICK_HIT,
  userToken,
  index,
  objectIDs,
  searchTerm,
  positions,
});
